import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function RecommendationAPI(): BringozApi {
  return {
    base: `/recommendation`,
    infiniteScroll: {
      address: `/recommendation`,
      cmd: 'GET'
    },
    actions: {
    }
  }
}

angular
  .module('bringoz.admin.recommendation')
  .factory('RecommendationAPI', RecommendationAPI);

